// Sample post data for demonstration
const planData = [
  {
    "plan": "silver",
    "planName": "Silver",
    "price": "100K",
    "duration": "course",
    "features": [
      "Each course payment",
    ],
    "href": "/",
    "buttonText": "All courses",
    "buttonIcon": ""
  },
  {
    "plan": "gold",
    "planName": "Gold",
    "price": "150K",
    "duration": "monthly",
    "features": [
      "Monthly payment",
    ],
    "href": "",
    "buttonText": "Upgrade now",
    "buttonIcon": <span className="icon"><svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.479 8.11445C13.6178 8.74903 13.6219 9.5473 12.479 10.2647L3.6482 16.2205C2.53862 16.8126 1.78502 16.463 1.70591 15.1817L1.66844 2.71652C1.64346 1.53629 2.61564 1.20283 3.54203 1.7687L12.479 8.11445Z"
        stroke="#705DF2"
        stroke-width="2"
      />
    </svg></span>
  },
  {
    "plan": "diamond",
    "planName": "Diamond",
    "price": "3M",
    "duration": "Own all courses",
    "features": [
      "Onetime payment",
      "Access for life",
    ],
    "href": "",
    "buttonText": "Upgrade now",
    "buttonIcon": <span className="icon"><svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.479 8.11445C13.6178 8.74903 13.6219 9.5473 12.479 10.2647L3.6482 16.2205C2.53862 16.8126 1.78502 16.463 1.70591 15.1817L1.66844 2.71652C1.64346 1.53629 2.61564 1.20283 3.54203 1.7687L12.479 8.11445Z"
        stroke="#705DF2"
        stroke-width="2"
      />
    </svg></span>
  }
]


export default planData;
